import mockNotifications from "../data/notifications";
import axios from "axios";
import formatDate from "../../mixins/formatDate";
import CONSTANTS from "../../settings/constants";

/* eslint no-console: "off" */
const fetchNotifications = (filters) => {
  let activeFiltersJoin = filters.join(",");

  let firstDayOfLastYear = formatDate(
    new Date(new Date().getFullYear() - 1, 0, 1)
  );

  let date = new Date();
  let today = formatDate(date.setDate(date.getDate() + 1));

  let notificationsApi = `${CONSTANTS.FETCH_NOTIFICATIONS}?ids=${activeFiltersJoin}&startDate=${firstDayOfLastYear}&endDate=${today}`;
  // let notificationsApi = `${CONSTANTS.FETCH_NOTIFICATIONS}?ids=engadinew-p&startDate=${firstDayOfLastYear}&endDate=${today}`;

  return new Promise(function(resolve) {
    //eslint-disable-next-line
    NativeJS.debugLog(`Calling ${notificationsApi}`);
    let start = Date.now();

    //eslint-disable-next-line
    NativeJS.debugLog(`starting call ${notificationsApi}`);

    axios
      .get(`${notificationsApi}`)
      .then((response) => {
        let end = Date.now();
        let time = (end - start) / 1000;
        //eslint-disable-next-line
        NativeJS.debugLog(
          `${notificationsApi} responded after ${time} seconds with a ${response.status} code`
        );
        //eslint-disable-next-line
        NativeJS.debugLog(
          `${notificationsApi} Response body: ${JSON.stringify(
            response.data,
            null,
            2
          )}`
        );

        const dateSortedNotifications = response.data.sort(function(a, b) {
          return new Date(b.timestamp) - new Date(a.timestamp);
        });

        resolve(dateSortedNotifications);
      })
      .catch((error) => {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `error calling ${notificationsApi}: ${JSON.stringify(error, null, 2)}`
        );
      });
  });
};

const fetchMockNotifications = () => {
  return new Promise(function(resolve) {
    setTimeout(function() {
      const dateSortedMockNotifications = mockNotifications.sort(function(
        a,
        b
      ) {
        return new Date(b.timestamp) - new Date(a.timestamp);
      });

      resolve(dateSortedMockNotifications);
    }, 2000);
  });
};

export default { fetchNotifications, fetchMockNotifications };
